<div class="custom-mat-dialog-form non-overflow">
  <div>
    @if (!executed) {
      <h3>Execute Test Case: {{this.testCase.Name}} ({{this.testCase.TestCaseID}})</h3>
    }
    @if (executed) {
      <h3>Test Case: {{this.testCase.Name}} ({{this.testCase.TestCaseID}}) initialized successfully in {{body.UnitId}}</h3>
    }
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (!executed) {
        <div class="mt-2">
          @if (!executed) {
            <div class="">
              <p class="p-darkgrey">** For security reasons, all simulations will be performed in already provisioned units in STABLE stage.</p>
            </div>
          }
          <div class="input div-flex">
            @if (showFilter || !deviceList) {
              <mat-form-field class="search-input">
                <!--<mat-label>Search Device Id / Unit Id</mat-label>-->
                <input placeholder="Device Id / Unit Id"
                  matInput
                  (keyup)="applyFilter($event)">
                </mat-form-field>
              }
            </div>
            <div class="input div-flex">
              @if (deviceList) {
                <mat-select class="form-control" formControlName="unitId"
                  panelClass="testcase-class"
                  [ngClass]="{ 'is-invalid': submitted && f['unitId'].errors }" readonly [(ngModel)]="unitId">
                  <mat-option [value]="''">Select</mat-option>
                  @for (device of deviceList; track device) {
                    <mat-option [value]="device.UnitID">
                      {{ device.DeviceId }} - {{ device.UnitID }} - {{device.ElevatorNickname}} - {{device.BuildingAddr1}} - {{device.BranchNumber}}
                    </mat-option>
                  }
                </mat-select>
              }
            </div>
            @if (submitted && f['unitId'].errors) {
              <div class="invalid-feedback">
                <div class="error-div">Please select an unit in order to execute that Test Case</div>
              </div>
            }
          </div>
        }

        <div>
          <div class="mt-2 right">
            <button type="button"
              class="btn btn-danger"
              (click)="onNoClick()">
              Close
            </button>
            @if (!executed) {
              <button type="button"
                class="btn btn-primary"
                (click)="onSubmit()">
                Send
              </button>
            }
            @if (executed && defaults.stage === 0) {
              <button type="button"
                class="btn btn-primary"
                (click)="openDscLink()">
                Go to DSC
              </button>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
